import * as React from 'react';
import { Image, PrimaryButton, ImageFit, ActionButton, IIconProps, FontSizes, mergeStyleSets } from '@fluentui/react/';
import { useSecurityRoles } from '../hooks/useSecurityRoles';

import ReservationBlockingModal from '../features/healthFacility/ReservationBlockingModal';
import { Permission } from '../defs/permission';
import { security, units } from '../features/security/thunks/securityThunk';
import { useDispatch, useSelector } from 'react-redux';
import Theme from '../components/themes/Theme';
import { FontFaces } from '../defs/fonts';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../api/client';
import { AppDispatch } from '../app/store';


export const Welfare2024Download = createAsyncThunk(
    'item/Welfare2024Download',
    async (args: { token?: string | undefined }) => {
        const response = await client.downloadPost("Files", { form: { fileName: "Welfare2024.pdf" }, page: {} }, 'Welfare2024', args.token)
        return response
    }
)

export default () => {

    const dispatch: AppDispatch = useDispatch();

    const roles = useSecurityRoles()
    const isHF = roles.isHF;
    const credential = useSelector(security)?.credential

    if (roles.isHFAffiliation) {
        document.location.href = '/HealthFacilityAffiliation/'
    }

    const unitsContext = useSelector(units)

    const canViewMagazine = (): boolean => {
        var permissions = unitsContext?.units.permissions
        if (!!!permissions) return false

        var controllerPermissions = permissions["magazine"]
        if (!!!controllerPermissions) return false;

        if (!controllerPermissions.find((cp: Permission) => cp == Permission.Read)) return false;

        return true
    }

    const welfare2024Download = () => {
        if (!!!isHF) {
            return
        }

        if (!!!credential) {
            return
        }

        dispatch(Welfare2024Download({ token: credential.token }))
    }

    const magazineContainerStyle: Partial<React.CSSProperties> = {
        textAlign: "right"
    }
    const magazineButtonStyle: Partial<React.CSSProperties> = {
        //color: "#4b858e",
        cursor: "pointer",
        fontFamily: "Montserrat",
        fontSize: FontSizes.large,
        minWidth: 166,
        paddingTop: 12
    }
    const newsIcon: IIconProps = {
        iconName: 'News',
        style: {
            color: "#ff8200",
            fontSize: FontSizes.xLargePlus,
        }
    };

    const contentStyles = mergeStyleSets({
        container: {
            maxHeight: "80vh",
            padding: "30px 0 20px",
            width: 800
        },
        content: {
            overflowY: "visible",
        },
        header: {
            color: Theme.fluent.palette.themePrimary,
            fontFamily: FontFaces.montserrat,
            fontSize: FontSizes.xxLarge,
            fontVariant: 'small-caps',
            fontWeight: 600,
            padding: "10px 0 0",
            textAlign: "center"
        },
        body: {
            fontFamily: FontFaces.openSans,
            fontSize: 16,
            overflowY: "visible",
            padding: "30px 32px 24px",
            textAlign: "center",
            selectors: {
                p: { margin: '16px 0 0' },
                'span.orange': { color: "#ff8200", fontWeight: 500 },
                'span.download': { color: "#ff8200", cursor: "pointer", fontWeight: 500, textDecoration: "underline" },
            },
        },
        primaryButton: {
            padding: "0 0 50px",
            textAlign: "center",
            selectors: {
                button: { backgroundColor: "#ff8200", borderColor: "#ff8200", borderRadius: 4, color: Theme.fluent.palette.white, fontWeight: 600, width: 200 },
                'button:active': { backgroundColor: Theme.fluent.palette.white, borderColor: "#ff8200", color: "#ff8200" },
                'button:hover': { backgroundColor: Theme.fluent.palette.white, borderColor: "#ff8200", color: "#ff8200" }
            },
        },
        standardButton: {
            padding: "0 32px",
            textAlign: "right",
            selectors: {
                button: { backgroundColor: Theme.fluent.palette.white, borderColor: "#ff8200", borderRadius: 4, color: "#ff8200", fontSize: "0.7em", margin: '8px 0', width: 180 },
                'button:active': { backgroundColor: "#ff8200", borderColor: "#ff8200", color: Theme.fluent.palette.white },
                'button:hover': { backgroundColor: "#ff8200", borderColor: "#ff8200", color: Theme.fluent.palette.white }
            },
        }
    });


    const body =
        <>
            <div style={{ backgroundColor: "#fff", borderRadius: 4, marginTop: "14vh", padding: "0 20px", marginBottom: "22vh" }}>
                <Image
                    src="/assets/media/images/odontonetwork-oral-health-care-management-logo-vector.png"
                    alt="ONHC"
                    imageFit={ImageFit.centerContain}
                    height="26vh"
                    style={{
                        MozUserSelect: "none",
                        WebkitUserSelect: "none",
                        msUserSelect: "none"
                    }}
                    draggable={false}
                />
            </div>
        </>

    return <>
        <ReservationBlockingModal />
        {canViewMagazine() && <>
            <div style={magazineContainerStyle}>
                <ActionButton style={magazineButtonStyle} iconProps={newsIcon} allowDisabledFocus href="/magazine/">
                    News e Promozioni
                </ActionButton>
            </div>
        </>}

        {body}
    </>
}
